import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getCotizaciones, getClientes, createCotizacion, updateEstadoCot, getContactos, createContacto, createCliente, getProductos, crearProducto, getProximoCotizacion, setProximoCotizacion, API_BASE, getCondiciones, crearCondicion, actualizarCondicion, borrarCondicion } from '../services/api';
import api from '../services/api';
import { coincide } from '../utils/buscar';
import AutocompleteInput from '../components/AutocompleteInput';
import RibbonActions from '../components/RibbonActions';
import FiltroPanel from '../components/FiltroPanel';
import ClienteModal from '../components/ClienteModal';
import { ModalEmail } from '../components/PrintView';

const ESTADOS   = ['borrador','enviada','aprobada','rechazada','vencida','facturada'];
const EC        = { aprobada:'#10b981', enviada:'#3b82f6', borrador:'#94a3b8', rechazada:'#ef4444', vencida:'#f59e0b', facturada:'#8b5cf6' };
const IVA_OPTS  = [{ v: 0, l: '0%' }, { v: 5, l: '5%' }, { v: 19, l: '19%' }];
const IMPO_OPTS = [{ v: 0, l: '0%' }, { v: 4, l: '4%' }, { v: 8, l: '8%' }, { v: 16, l: '16%' }];
const EMPTY_CLIENTE = () => ({ razon_social:'', nit:'', email:'', telefono:'', ciudad:'', direccion:'', contacto_nombre:'', contacto_cargo:'' });
const EMPTY_PRODUCTO = () => ({ codigo:'', nombre:'', descripcion:'', precio_unitario:0, iva_pct:19, impoconsumo_pct:0, unidad:'und' });


if (!document.getElementById('spin-style')) {
  const st = document.createElement('style');
  st.id = 'spin-style';
  st.textContent =
    '@keyframes spin { to { transform: rotate(360deg); } }' +
    // Esquina de redimensionar de la descripción: fondo del color del campo (no
    // transparente) con las líneas diagonales de agarre encima.
    'textarea.desc-cell::-webkit-resizer { background-color: #0f172a; border-bottom-right-radius: 6px; }';
  document.head.appendChild(st);
}

// Buscador de productos por nombre o código, con autocompletar.
function ProductoPicker({ value, onChangeText, onPick, onNew }) {
  const [q, setQ] = useState(value || '');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const taRef = useRef(null);
  // Ajusta la altura al contenido para que la descripción siempre se vea completa.
  const autosize = (el) => { if (!el) return; el.style.height = 'auto'; el.style.height = Math.max(34, Math.min(el.scrollHeight, 220)) + 'px'; };
  useEffect(() => { setQ(value || ''); }, [value]);
  useEffect(() => { autosize(taRef.current); }, [q]);
  useEffect(() => {
    if (!open) return;
    const term = (q || '').trim();
    if (term.length < 2) { setResults([]); return; }
    const t = setTimeout(async () => {
      try { const { data } = await getProductos(term); setResults((data || []).slice(0, 8)); }
      catch { setResults([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);
  const fmtP = (n) => Number(n) > 0 ? '$' + Number(n).toLocaleString('es-CO') : '';
  return (
    <div style={{ position: 'relative' }}>
      <textarea ref={taRef} className="desc-cell" style={{ ...s.inputSm, resize: 'vertical', height: 34, minHeight: 34, minWidth: '100%', overflow: 'hidden', fontFamily: 'inherit', lineHeight: '17px', padding: '8px 8px', position: 'relative', zIndex: 5 }}
        rows={1} placeholder="Descripción o buscar producto…" value={q}
        onChange={e => { setQ(e.target.value); onChangeText(e.target.value); setOpen(true); autosize(e.target); }}
        onFocus={e => { setOpen(true); autosize(e.target); }}
        onBlur={e => { setTimeout(() => setOpen(false), 150); }} />
      {open && (
        <div style={s.acDropdown}>
          <div style={{ ...s.acItem, ...s.acItemNew }} onMouseDown={() => { onNew(q); setOpen(false); }}>
            <div style={{ color: '#7dd3fc', fontSize: 12, fontWeight: 500 }}>➕ Crear nuevo producto…</div>
          </div>
          {results.map(p => (
            <div key={p.id} style={s.acItem} onMouseDown={() => { onPick(p); setOpen(false); }}>
              <div style={{ color: '#f1f5f9', fontSize: 12 }}>{p.nombre}</div>
              <div style={{ color: '#64748b', fontSize: 11 }}>
                {p.codigo ? p.codigo + ' · ' : ''}{p.unidad} · IVA {p.iva_pct}%{fmtP(p.precio_unitario) ? ' · ' + fmtP(p.precio_unitario) : ''}
              </div>
            </div>
          ))}
          {(q || '').trim().length === 0 && results.length === 0 && (
            <div style={{ ...s.acItem, color: '#64748b', fontSize: 11 }}>Escribe para buscar un producto…</div>
          )}
        </div>
      )}
    </div>
  );
}

// Buscador por CÓDIGO: al escribir un código trae el producto y llena la fila.
function CodigoPicker({ value, onChangeText, onPick, onNew }) {
  const [q, setQ] = useState(value || '');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { setQ(value || ''); }, [value]);
  useEffect(() => {
    if (!open) return;
    const term = (q || '').trim();
    if (term.length < 1) { setResults([]); return; }
    const t = setTimeout(async () => {
      try { const { data } = await getProductos(term); setResults((data || []).slice(0, 8)); }
      catch { setResults([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);
  const fmtP = (n) => Number(n) > 0 ? '$' + Number(n).toLocaleString('es-CO') : '';
  return (
    <div style={{ position: 'relative' }}>
      <input style={s.inputSm} placeholder="Código" value={q}
        onChange={e => { setQ(e.target.value); onChangeText(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)} />
      {open && (
        <div style={{ ...s.acDropdown, minWidth: 280 }}>
          {onNew && (
            <div style={{ ...s.acItem, ...s.acItemNew }} onMouseDown={() => { onNew(q); setOpen(false); }}>
              <div style={{ color: '#7dd3fc', fontSize: 12, fontWeight: 500 }}>➕ Crear nuevo producto…</div>
            </div>
          )}
          {results.map(p => (
            <div key={p.id} style={s.acItem} onMouseDown={() => { onPick(p); setOpen(false); }}>
              <div style={{ color: '#f1f5f9', fontSize: 12 }}>{p.codigo ? <b>{p.codigo}</b> : '(sin código)'} · {p.nombre}</div>
              <div style={{ color: '#64748b', fontSize: 11 }}>{p.unidad} · IVA {p.iva_pct}%{fmtP(p.precio_unitario) ? ' · ' + fmtP(p.precio_unitario) : ''}</div>
            </div>
          ))}
          {(q || '').trim().length === 0 && results.length === 0 && (
            <div style={{ ...s.acItem, color: '#64748b', fontSize: 11 }}>Escribe un código para buscar…</div>
          )}
        </div>
      )}
    </div>
  );
}

// Buscador de clientes por nombre o NIT, con autocompletar.
function ClientePicker({ clientes, value, onSelect, onNew }) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const pickedRef = useRef(false);
  const selected = clientes.find(c => c.id === value);
  const term = q.trim().toLowerCase();
  const filtered = (term.length >= 1
    ? clientes.filter(c => (c.razon_social || '').toLowerCase().includes(term) || (c.nit || '').includes(q.trim()))
    : clientes
  ).slice(0, 12);
  const pick = (id) => { pickedRef.current = true; onSelect(id); setQ(''); setOpen(false); };
  // Al salir del campo: si el usuario escribió y hay UNA sola coincidencia, la
  // aplica. Evita que el texto escrito se descarte en silencio dejando el
  // cliente anterior (bug: cambiar la empresa "no cambiaba" al no hacer clic).
  const commitTyped = () => {
    if (!pickedRef.current && term && filtered.length === 1) onSelect(filtered[0].id);
    pickedRef.current = false; setQ(''); setOpen(false);
  };
  return (
    <div style={{ position: 'relative' }}>
      <input style={s.input} placeholder="Buscar cliente por nombre o NIT…"
        value={open ? q : (selected?.razon_social || '')}
        onChange={e => { setQ(e.target.value); setOpen(true); }}
        onFocus={() => { pickedRef.current = false; setQ(''); setOpen(true); }}
        onKeyDown={e => { if (e.key === 'Enter' && filtered.length > 0) { e.preventDefault(); pick(filtered[0].id); } }}
        onBlur={() => setTimeout(commitTyped, 150)} />
      {open && (
        <div style={s.acDropdown}>
          <div style={{ ...s.acItem, ...s.acItemNew }} onMouseDown={() => { pickedRef.current = true; onNew(); setQ(''); setOpen(false); }}>
            <div style={{ color: '#7dd3fc', fontSize: 12, fontWeight: 500 }}>➕ Crear nuevo cliente…</div>
          </div>
          {filtered.map(c => (
            <div key={c.id} style={s.acItem} onMouseDown={() => pick(c.id)}>
              <div style={{ color: '#f1f5f9', fontSize: 12 }}>{c.razon_social}</div>
              <div style={{ color: '#64748b', fontSize: 11 }}>{c.nit}{c.email ? ' · ' + c.email : ''}</div>
            </div>
          ))}
          {filtered.length === 0 && <div style={{ ...s.acItem, color: '#64748b', fontSize: 12 }}>Sin coincidencias</div>}
        </div>
      )}
    </div>
  );
}

export default function Cotizaciones() {
  const navigate = useNavigate();
  const location = useLocation();
  const [lista, setLista] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [contactos, setContactos] = useState([]);
  const [showNuevoContacto, setShowNuevoContacto] = useState(false);
  const [nuevoContacto, setNuevoContacto] = useState({ nombre:'', cargo:'', email:'', telefono:'' });
  const [savingContacto, setSavingContacto] = useState(false);
  const [errorContacto, setErrorContacto] = useState('');
  // Recuerda el filtro (empresa/estado/año) durante la sesión: al abrir una
  // cotización y volver, la lista sigue filtrada por la misma empresa.
  const savedCotF = (() => { try { return JSON.parse(sessionStorage.getItem('cotFiltros')) || {}; } catch { return {}; } })();
  const [filtro, setFiltro] = useState(savedCotF.filtro || '');
  const [busq, setBusq] = useState(savedCotF.busq || '');
  const [anio, setAnio] = useState(savedCotF.anio || '');
  useEffect(() => { try { sessionStorage.setItem('cotFiltros', JSON.stringify({ filtro, busq, anio })); } catch {} }, [filtro, busq, anio]);
  const [orden, setOrden] = useState({ col: 'numero', dir: 'desc' }); // col: 'numero' | 'fecha'
  const [filtroOpen, setFiltroOpen] = useState(false);
  const filtroRef = useRef(null);
  const [diasValidez, setDiasValidez] = useState('');
  const [vista, setVista] = useState('actuales');   // 'actuales' | 'historico' (Siigo)
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ cliente_id:'', contacto_id:'', fecha_vencimiento:'', notas:'' });
  const [condiciones, setCondiciones] = useState([]);
  const [condModal, setCondModal] = useState(false);
  const [condForm, setCondForm] = useState({ id:null, titulo:'', texto:'' });
  const loadCondiciones = () => getCondiciones().then(r => setCondiciones(r.data)).catch(() => {});
  const lineaCond = (c) => `${c.titulo}: ${c.texto}`;
  const condUsada = (c) => (form.notas || '').includes(lineaCond(c));
  const insertarCondicion = (c) => setForm(f => {
    const linea = lineaCond(c);
    const notas = f.notas || '';
    if (notas.includes(linea)) { // ya está → la quito (toggle)
      // Quita el bloque COMPLETO por substring (la condición puede ser multilínea;
      // filtrar renglón por renglón no la encontraba y el toggle quedaba activo).
      // Se elimina también el salto de línea con que se insertó.
      const sinBloque = notas.includes('\n' + linea)
        ? notas.replace('\n' + linea, '')
        : notas.replace(linea, '');
      return { ...f, notas: sinBloque.replace(/\n{3,}/g, '\n\n').trim() };
    }
    return { ...f, notas: (notas ? notas.trimEnd() + '\n' : '') + linea };
  });
  const guardarCondicion = async () => {
    if (!condForm.titulo || !condForm.texto) return alert('Título y texto son requeridos');
    try {
      if (condForm.id) await actualizarCondicion(condForm.id, { titulo: condForm.titulo, texto: condForm.texto });
      else await crearCondicion({ titulo: condForm.titulo, texto: condForm.texto });
      setCondForm({ id:null, titulo:'', texto:'' });
      loadCondiciones();
    } catch (e) { alert(e.response?.data?.error || 'Error al guardar'); }
  };
  const eliminarCondicion = async (c) => {
    if (!window.confirm(`¿Eliminar la condición "${c.titulo}"?`)) return;
    try { await borrarCondicion(c.id); loadCondiciones(); } catch (e) { alert('No se pudo eliminar'); }
  };
  const [showCliente, setShowCliente] = useState(false);
  const [nuevoCliente, setNuevoCliente] = useState(EMPTY_CLIENTE());
  const [savingCliente, setSavingCliente] = useState(false);
  const [errorCliente, setErrorCliente] = useState('');
  const [showProducto, setShowProducto] = useState(false);
  const [nuevoProducto, setNuevoProducto] = useState(EMPTY_PRODUCTO());
  const [savingProducto, setSavingProducto] = useState(false);
  const [errorProducto, setErrorProducto] = useState('');
  const [productoRow, setProductoRow] = useState(null);
  const [items, setItems] = useState([{ codigo:'', descripcion:'', observacion:'', cantidad:1, unidad:'und', precio_unitario:0, descuento_pct:0, iva_pct:19, impoconsumo_pct:0 }]);
  const [saving, setSaving] = useState(false);
  const [preview, setPreview] = useState(null);
  const [pdfUrl,  setPdfUrl]  = useState(null);
  const [pdfAspect, setPdfAspect] = useState(1123 / 794); // alto/ancho de la hoja (A4 por defecto)
  const [pdfLoading, setPdfLoading] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const blobRef = useRef(null);
  const [modalCopiar, setModalCopiar] = useState(null); // cotización origen
  const [copiarClienteId, setCopiarClienteId] = useState('');
  const [copiando, setCopiando] = useState(false);
  const [copiarDe,   setCopiarDe]   = useState(null);
  const [editandoId, setEditandoId] = useState(null);

  const load = () => getCotizaciones(filtro ? { estado: filtro } : {}).then(r => setLista(r.data));
  // Cambio manual de estado desde la lista (útil cuando salió impresa/WhatsApp, sin correo).
  const cambiarEstado = async (id, estado) => {
    try { await updateEstadoCot(id, estado); load(); }
    catch (e) { alert(e.response?.data?.error || 'No se pudo cambiar el estado'); }
  };
  // Crear un contacto del cliente al vuelo (sin salir del modal de cotización).
  const guardarContactoRapido = async () => {
    if (!form.cliente_id) return;
    if (!nuevoContacto.nombre.trim()) return setErrorContacto('El nombre es obligatorio');
    setSavingContacto(true); setErrorContacto('');
    try {
      const { data } = await createContacto(form.cliente_id, nuevoContacto);
      const r = await getContactos(form.cliente_id);
      setContactos(r.data);
      setForm(f => ({ ...f, contacto_id: data.id }));   // dejarlo seleccionado
      setShowNuevoContacto(false);
      setNuevoContacto({ nombre:'', cargo:'', email:'', telefono:'' });
    } catch (e) {
      setErrorContacto(e.response?.data?.error || 'No se pudo crear el contacto');
    } finally { setSavingContacto(false); }
  };

  const configurarNumeracion = async () => {
    try {
      const { data } = await getProximoCotizacion();
      const actual = `COT-${data.anio}-${String(data.proximo).padStart(4, '0')}`;
      const nuevo = window.prompt(
        `La próxima cotización sería ${actual}.\n\nSi venís migrando de otro sistema, ingresá el número consecutivo con el que querés continuar (solo el número, ej: 305):`,
        data.proximo);
      if (nuevo === null) return;
      const n = parseInt(nuevo, 10);
      if (!Number.isInteger(n) || n < 1) return alert('Número inválido (debe ser un entero ≥ 1)');
      await setProximoCotizacion(n);
      alert(`✅ La próxima cotización será COT-${data.anio}-${String(n).padStart(4, '0')}`);
    } catch (e) { alert(e.response?.data?.error || 'Error'); }
  };

  useEffect(() => {
    load();
    loadCondiciones();
    getClientes().then(r => {
      setClientes(r.data);
      // Manejar ?editar=id o ?copiar=id desde DetalleCotizacion
      const params = new URLSearchParams(location.search);
      const editarId = params.get('editar');
      const copiarId = params.get('copiar');
      if (editarId || copiarId) {
        const targetId = editarId || copiarId;
        api.get(`/cotizaciones/${targetId}`).then(async res => {
          const orig = res.data;
          // Cargar contactos del cliente antes de abrir el modal
          try {
            const ctRes = await getContactos(orig.cliente_id);
            setContactos(ctRes.data);
          } catch { setContactos([]); }
          setForm({ cliente_id: orig.cliente_id, contacto_id: orig.contacto_id || '', fecha_vencimiento: orig.fecha_vencimiento || '', notas: orig.notas || '' });
          setItems(orig.items.map(it => ({ codigo: it.codigo || '', descripcion: it.descripcion || '', observacion: it.observacion || '', cantidad: Number(it.cantidad), unidad: it.unidad || 'und', precio_unitario: Number(it.precio_unitario), descuento_pct: Number(it.descuento_pct || 0), iva_pct: Number(it.iva_pct ?? 19), impoconsumo_pct: Number(it.impoconsumo_pct || 0) })));
          if (copiarId) setCopiarDe({ id: orig.id, mismoCliente: true });
          if (editarId) setEditandoId(orig.id);
          setModal(true);
          navigate('/cotizaciones', { replace: true });
        }).catch(() => {});
      }
    });
  }, []);
  useEffect(() => { load(); }, [filtro]);
  useEffect(() => {
    if (!filtroOpen) return;
    const h = (e) => { if (filtroRef.current && !filtroRef.current.contains(e.target)) setFiltroOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [filtroOpen]);

  const addItem    = () => setItems([...items, { codigo:'', descripcion:'', observacion:'', cantidad:1, unidad:'und', precio_unitario:0, descuento_pct:0, iva_pct:19, impoconsumo_pct:0 }]);
  const removeItem = i => setItems(items.filter((_,idx) => idx !== i));
  const updateItem = (i, k, v) => setItems(items.map((it, idx) => idx === i ? { ...it, [k]: v } : it));
  // "Mismo ítem" en varias filas: se identifica por código o, si no hay, por la descripción.
  const itemKey = (it) => (String(it.codigo || '').trim().toLowerCase()) || (String(it.descripcion || '').trim().toLowerCase());
  // Copia el precio de la fila i a TODAS las filas con el mismo ítem.
  const aplicarPrecioAIguales = (i) => {
    const k = itemKey(items[i]);
    if (!k) return;
    const precio = items[i].precio_unitario;
    setItems(items.map(x => itemKey(x) === k ? { ...x, precio_unitario: precio } : x));
  };
  const moveItem   = (i, dir) => {
    const next = [...items];
    const to = i + dir;
    if (to < 0 || to >= next.length) return;
    [next[i], next[to]] = [next[to], next[i]];
    setItems(next);
  };

  // Días de validez -> fecha de vencimiento (hoy + días)
  const setDiasFromInput = (v) => {
    setDiasValidez(v);
    const n = parseInt(v, 10);
    if (!isNaN(n) && n >= 0) {
      const d = new Date();
      d.setDate(d.getDate() + n);
      setForm(f => ({ ...f, fecha_vencimiento: d.toISOString().slice(0, 10) }));
    }
  };

  // Elegir un producto del catálogo llena el ítem
  const pickProducto = (i, p) => {
    setItems(prev => prev.map((it, idx) => idx === i ? {
      ...it,
      codigo: p.codigo || it.codigo,
      descripcion: p.nombre,
      precio_unitario: Number(p.precio_unitario) || it.precio_unitario,
      iva_pct: p.iva_pct != null ? Number(p.iva_pct) : it.iva_pct,
      unidad: p.unidad || it.unidad,
      impoconsumo_pct: Number(p.impoconsumo_pct || 0),
    } : it));
  };

  const openNuevoProducto = (rowIndex, nombreInicial) => {
    setProductoRow(rowIndex);
    setNuevoProducto({ ...EMPTY_PRODUCTO(), nombre: nombreInicial || '' });
    setErrorProducto('');
    setShowProducto(true);
  };
  const handleCrearProducto = async (e) => {
    e.preventDefault();
    if (!nuevoProducto.nombre) return setErrorProducto('El nombre es obligatorio');
    setSavingProducto(true); setErrorProducto('');
    try {
      const { data: prod } = await crearProducto(nuevoProducto);
      if (productoRow != null) pickProducto(productoRow, prod);
      setShowProducto(false);
    } catch (err) {
      setErrorProducto(err.response?.data?.error || 'Error al crear producto');
    } finally { setSavingProducto(false); }
  };

  const calcItem = (i) => {
    const base    = (Number(i.cantidad)||0) * (Number(i.precio_unitario)||0) * (1 - (Number(i.descuento_pct)||0)/100);
    const ivaVal  = base * (Number(i.iva_pct ?? 19)) / 100;
    const impoVal = base * (Number(i.impoconsumo_pct || 0)) / 100;
    return { base, ivaVal, impoVal, total: base + ivaVal + impoVal };
  };
  const brutoTotal  = items.reduce((s, i) => s + (Number(i.cantidad)||0) * (Number(i.precio_unitario)||0), 0);
  const subtotal    = items.reduce((s, i) => s + calcItem(i).base,    0);
  const descuento   = brutoTotal - subtotal;
  const iva         = items.reduce((s, i) => s + calcItem(i).ivaVal,  0);
  const impoconsumo = items.reduce((s, i) => s + calcItem(i).impoVal, 0);
  const total       = subtotal + iva + impoconsumo;

  const handleClienteChange = (cliente_id) => {
    setForm(f => ({ ...f, cliente_id, contacto_id: '' }));
    if (cliente_id) {
      getContactos(cliente_id).then(r => {
        setContactos(r.data);
        // Pre-seleccionar el contacto principal si existe
        const principal = r.data.find(c => c.es_principal);
        if (principal) setForm(f => ({ ...f, cliente_id, contacto_id: principal.id }));
      }).catch(() => setContactos([]));
    } else {
      setContactos([]);
    }
  };

  const handleCreate = async () => {
    if (!form.cliente_id || !form.fecha_vencimiento) return alert('Complete los campos requeridos');
    setSaving(true);
    try {
      let res;
      if (editandoId) {
        res = await api.put(`/cotizaciones/${editandoId}`, { ...form, items });
        setEditandoId(null);
      } else if (copiarDe) {
        // Guardar como copia — backend genera número con versión o nuevo consecutivo
        res = await api.post(`/cotizaciones/${copiarDe.id}/copiar`, {
          cliente_id: copiarDe.mismoCliente ? undefined : form.cliente_id,
          fecha_vencimiento: form.fecha_vencimiento,
          notas: form.notas,
          contacto_id: form.contacto_id || undefined,
          items,
        });
        setCopiarDe(null);
      } else {
        res = await createCotizacion({ ...form, items });
      }
      const cot = res.data;
      if (cot._versionada) alert(`Guardada como v${cot._version}`);
      // Resolver el email ANTES de resetear el form: contacto elegido -> email del cliente -> primer contacto con email
      const clienteSel  = clientes.find(c => c.id === form.cliente_id);
      const contactoSel = contactos.find(ct => ct.id === form.contacto_id);
      const emailDest = contactoSel?.email || clienteSel?.email || contactos.find(ct => ct.email)?.email || '';
      setModal(false);
      setForm({ cliente_id:'', contacto_id:'', fecha_vencimiento:'', notas:'' });
      setItems([{ codigo:'', descripcion:'', observacion:'', cantidad:1, unidad:'und', precio_unitario:0, descuento_pct:0, iva_pct:19, impoconsumo_pct:0 }]);
      load();
      // Abrir vista previa
      setPreview({ id: cot.id, numero: cot.numero, clienteEmail: emailDest });
      setPdfLoading(true);
      setPdfUrl(null);
      const token = localStorage.getItem('erp_token');
      const pdfRes = await fetch(`${API_BASE}/api/cotizaciones/${cot.id}/pdf?v=${Date.now()}`, { cache: 'no-store', headers: { Authorization: `Bearer ${token}` } });
      const blob = await pdfRes.blob();
      // Ajustar la ventana de preview a la altura real de la hoja (media hoja,
      // carta, A4…) leyendo el MediaBox del propio PDF; así no queda espacio
      // vacío bajo la cotización.
      try {
        const txt = new TextDecoder('latin1').decode(await blob.arrayBuffer());
        const m = txt.match(/MediaBox\s*\[\s*[\d.]+\s+[\d.]+\s+([\d.]+)\s+([\d.]+)/);
        if (m) { const w = parseFloat(m[1]), h = parseFloat(m[2]); if (w > 0 && h > 0) setPdfAspect(h / w); }
      } catch {}
      if (blobRef.current) URL.revokeObjectURL(blobRef.current);
      const url = URL.createObjectURL(blob);
      blobRef.current = url;
      setPdfUrl(url);
      setPdfLoading(false);
    } catch (e) { alert(e.response?.data?.error || 'Error al guardar'); }
    finally { setSaving(false); }
  };

  const handlePrint = () => {
    if (!pdfUrl) return;
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;';
    iframe.src = pdfUrl;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      iframe.contentWindow.print();
      setTimeout(() => document.body.removeChild(iframe), 60000);
    };
  };

  const handleDownload = () => {
    if (!pdfUrl || !preview) return;
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = `${String(preview.numero).replace(/[^\w.-]/g, '_')}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const closePreview = () => {
    if (blobRef.current) { URL.revokeObjectURL(blobRef.current); blobRef.current = null; }
    setPdfUrl(null);
    setPreview(null);
  };

  const abrirCopiar = (c) => { setModalCopiar(c); setCopiarClienteId(c.cliente_id); };

  const handleCopiar = async () => {
    setCopiando(true);
    try {
      // Cargar ítems del original
      const res = await api.get(`/cotizaciones/${modalCopiar.id}`);
      const orig = res.data;
      const mismoCliente = copiarClienteId === modalCopiar.cliente_id;

      // Cargar contactos del cliente (siempre, mismo o diferente)
      let contactoId = '';
      try {
        const ctRes = await getContactos(copiarClienteId);
        setContactos(ctRes.data);
        if (mismoCliente) {
          // Mantener el contacto original si existe en la lista
          contactoId = ctRes.data.find(c => c.id === orig.contacto_id)?.id || ctRes.data.find(c => c.es_principal)?.id || '';
        } else {
          contactoId = ctRes.data.find(c => c.es_principal)?.id || '';
        }
      } catch { setContactos([]); }

      setForm({ cliente_id: copiarClienteId, contacto_id: contactoId, fecha_vencimiento: orig.fecha_vencimiento || '', notas: orig.notas || '' });

      // Pre-cargar ítems
      setItems(orig.items.map(it => ({
        codigo: it.codigo || '',
        descripcion: it.descripcion || '',
        observacion: it.observacion || '',
        cantidad: Number(it.cantidad),
        unidad: it.unidad || 'und',
        precio_unitario: Number(it.precio_unitario),
        descuento_pct: Number(it.descuento_pct || 0),
        iva_pct: Number(it.iva_pct ?? 19),
        impoconsumo_pct: Number(it.impoconsumo_pct || 0),
      })));

      setCopiarDe({ id: modalCopiar.id, mismoCliente });
      setModalCopiar(null);
      setModal(true);
    } catch (e) { alert('Error al cargar la cotización'); }
    finally { setCopiando(false); }
  };

  // Derivados para el filtro (búsqueda + año); el estado se filtra en el servidor vía `load`.
  const fechaCot = (c) => c.fecha_emision || c.created_at;
  const anios = [...new Set(lista.map(c => { const d = fechaCot(c); return d ? new Date(d).getFullYear() : null; }).filter(Boolean))].sort((a, b) => b - a);
  const empresas = [...new Set(lista.map(c => c.cliente_nombre).filter(Boolean))].sort();
  const filtrada = lista.filter(c => {
    if (busq && !coincide(busq, c.numero, c.cliente_nombre, c.nit)) return false;
    if (anio) { const d = fechaCot(c); if (!d || String(new Date(d).getFullYear()) !== anio) return false; }
    return true;
  });
  const totalF = filtrada.reduce((a, c) => a + Number(c.total || 0), 0);
  // Clave numérica del consecutivo (año*1e6 + número) para ordenar por número
  // sin depender de la fecha; ignora el sufijo -vN de las versiones.
  const numKey = (c) => {
    const s = String(c.numero || '').replace(/-v\d+$/, '');
    const p = s.match(/\d+/g) || [];
    const anio = p.length >= 2 ? Number(p[p.length - 2]) : 0;
    const cons = p.length >= 1 ? Number(p[p.length - 1]) : 0;
    return anio * 1000000 + cons;
  };
  // Orden por número (por defecto) o por fecha de emisión, según el encabezado.
  const ordenada = [...filtrada].sort((a, b) => {
    const va = orden.col === 'fecha' ? new Date(a.fecha_emision || 0).getTime() : numKey(a);
    const vb = orden.col === 'fecha' ? new Date(b.fecha_emision || 0).getTime() : numKey(b);
    return orden.dir === 'desc' ? vb - va : va - vb;
  });

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Cotizaciones</h1><p style={s.sub}>Gestión de propuestas comerciales</p></div>
        <RibbonActions><div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <FiltroPanel
            fields={[
              { tipo: 'input', label: 'Buscar', value: busq, onChange: setBusq, placeholder: 'Número, cliente o NIT…', suggestions: empresas, width: 230 },
              { tipo: 'select', label: 'Estado', value: filtro, onChange: setFiltro, capitalize: true, options: [{ value: '', label: 'Todas' }, ...ESTADOS.map(e => ({ value: e, label: e }))] },
              { tipo: 'select', label: 'Año', value: anio, onChange: setAnio, options: [{ value: '', label: 'Todos' }, ...anios.map(a => ({ value: String(a), label: String(a) }))] },
            ]}
            onClear={() => { setFiltro(''); setBusq(''); setAnio(''); }}
          />
          <button style={{ ...s.btnPrimary, background: 'transparent', color: '#93c5fd', border: '1px solid #334155' }} onClick={configurarNumeracion} title="Fijar el próximo número de cotización (migración)">⚙ Numeración</button>
          <button style={s.btnPrimary} onClick={() => setModal(true)}>+ Nueva cotización</button>
        </div></RibbonActions>
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 0 12px' }}>
        <span style={{ color: '#64748b', fontSize: 12, fontFamily: 'ui-monospace,monospace' }}>{filtrada.length} de {lista.length} · ${totalF.toLocaleString('es-CO')}</span>
      </div>

      {/* Tabla */}
      <div style={s.card}>
        <table style={s.table}>
          <thead>
            <tr>{['Número','Cliente','Fecha emisión','Vencimiento','Total','Estado','Acciones'].map(h => {
              const col = h === 'Número' ? 'numero' : h === 'Fecha emisión' ? 'fecha' : null;
              if (!col) return <th key={h} style={s.th}>{h}</th>;
              const active = orden.col === col;
              return (
                <th key={h} style={{ ...s.th, cursor:'pointer', userSelect:'none' }}
                    onClick={() => setOrden(o => o.col === col ? { col, dir: o.dir === 'desc' ? 'asc' : 'desc' } : { col, dir: 'desc' })}
                    title={`Ordenar por ${h.toLowerCase()}`}>
                  {h} {active ? (orden.dir === 'desc' ? '↓' : '↑') : '↕'}
                </th>
              );
            })}</tr>
          </thead>
          <tbody>
            {filtrada.length === 0 && <tr><td colSpan={7} style={s.empty}>{lista.length ? 'Ninguna coincide con el filtro' : 'Sin cotizaciones'}</td></tr>}
            {ordenada.map(c => (
              <tr key={c.id} style={s.tr}>
                <td style={{ ...s.td, color:'#93c5fd', cursor:'pointer', whiteSpace:'nowrap' }} onClick={() => navigate(`/cotizaciones/${c.id}`)}>{String(c.numero).replace(/-v\d+$/, '')}{Number(c.version) > 1 && <span style={{ marginLeft:6, fontSize:11, color:'#fbbf24', background:'#422006', border:'1px solid #a16207', borderRadius:4, padding:'1px 5px' }}>V{c.version}</span>}</td>
                <td style={s.td}>{c.cliente_nombre}</td>
                <td style={s.td}>{new Date(c.fecha_emision).toLocaleDateString('es-CO')}</td>
                <td style={s.td}>{new Date(c.fecha_vencimiento).toLocaleDateString('es-CO')}</td>
                <td style={s.td}>${Number(c.total).toLocaleString('es-CO')}</td>
                <td style={s.td}>
                  {c.estado === 'borrador' ? (
                    // Solo en borrador (= aún no enviada por correo) se permite marcarla "enviada"
                    // a mano, para cuando salió impresa o por WhatsApp.
                    <select value={c.estado} onChange={e => cambiarEstado(c.id, e.target.value)} title="Marcar como enviada (si salió impresa o por WhatsApp)"
                      style={{ ...s.badge, background:EC[c.estado]+'22', color:EC[c.estado], border:`1px solid ${EC[c.estado]}55`, cursor:'pointer', appearance:'none', WebkitAppearance:'none', textTransform:'capitalize', fontWeight:600, padding:'3px 9px', borderRadius:10 }}>
                      <option value="borrador" style={{ color:'#111', background:'#fff' }}>borrador</option>
                      <option value="enviada" style={{ color:'#111', background:'#fff' }}>enviada</option>
                    </select>
                  ) : (
                    <span style={{ ...s.badge, background:EC[c.estado]+'22', color:EC[c.estado] }}>{c.estado}</span>
                  )}
                </td>
                <td style={s.td}>
                  <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                    {c.estado === 'aprobada' && (
                      <button style={s.btnFacturar} onClick={() => navigate(`/cotizaciones/${c.id}`)}>
                        ⚡ Facturar
                      </button>
                    )}
                    <button style={s.btnCopy} title="Copiar cotización" onClick={() => abrirCopiar(c)}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="14" height="14"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                      Copiar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal crear */}
      {modal && (
        <div style={s.overlay}>
          <div style={s.modal}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>{editandoId ? 'Editar cotización' : copiarDe ? 'Copiar cotización' : 'Nueva cotización'}</h2>
              <button style={s.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            <div style={s.modalBody}>
              <div style={s.row2}>
                <div style={s.field}>
                  <label style={s.label}>Cliente *</label>
                  <ClientePicker clientes={clientes} value={form.cliente_id}
                    onSelect={handleClienteChange}
                    onNew={() => { setNuevoCliente(EMPTY_CLIENTE()); setErrorCliente(''); setShowCliente(true); }} />
                </div>
                <div style={s.field}>
                  <label style={s.label}>Validez (días → vence) *</label>
                  <div style={{ display:'flex', gap:8 }}>
                    <input style={{ ...s.input, width:90, flexShrink:0 }} type="number" min="0" placeholder="Días"
                      value={diasValidez} onChange={e => setDiasFromInput(e.target.value)} title="Días de validez de la oferta" />
                    <input style={s.input} type="date" value={form.fecha_vencimiento}
                      onChange={e => { setForm({...form, fecha_vencimiento:e.target.value}); setDiasValidez(''); }} />
                  </div>
                </div>
              </div>

              {form.cliente_id && (
                <div style={s.field}>
                  <label style={s.label}>
                    Contacto para envío de propuesta
                    {contactos.length === 0 && <span style={s.hint}> — este cliente no tiene contactos registrados</span>}
                    <button type="button" onClick={() => { setShowNuevoContacto(v => !v); setErrorContacto(''); }}
                      style={{ marginLeft:8, background:'none', border:'none', color:'#3b82f6', fontSize:12, fontWeight:600, cursor:'pointer' }}>
                      {showNuevoContacto ? '× Cancelar' : '➕ Nuevo contacto'}
                    </button>
                  </label>
                  {contactos.length > 0 ? (
                    <select style={s.input} value={form.contacto_id} onChange={e => setForm({...form, contacto_id:e.target.value})}>
                      <option value="">Sin contacto específico</option>
                      {contactos.map(c => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}{c.cargo ? ` — ${c.cargo}` : ''}{c.email ? ` <${c.email}>` : ''}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <div style={s.noContactos}>
                      {(() => {
                        const em = clientes.find(c => c.id === form.cliente_id)?.email;
                        return em
                          ? <>📧 Se enviará la propuesta a: <b style={{ color:'#93c5fd' }}>{em}</b></>
                          : '⚠️ Sin email registrado. Agrega un contacto aquí mismo con "➕ Nuevo contacto".';
                      })()}
                    </div>
                  )}
                  {showNuevoContacto && (
                    <div style={{ marginTop:8, padding:10, background:'#0f172a', border:'1px solid #1e293b', borderRadius:8 }}>
                      {errorContacto && <div style={{ color:'#fca5a5', fontSize:12, marginBottom:6 }}>{errorContacto}</div>}
                      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                        <input style={s.input} placeholder="Nombre *" value={nuevoContacto.nombre} onChange={e => setNuevoContacto({...nuevoContacto, nombre:e.target.value})} />
                        <input style={s.input} placeholder="Cargo" value={nuevoContacto.cargo} onChange={e => setNuevoContacto({...nuevoContacto, cargo:e.target.value})} />
                        <input style={s.input} type="email" placeholder="Correo" value={nuevoContacto.email} onChange={e => setNuevoContacto({...nuevoContacto, email:e.target.value})} />
                        <input style={s.input} placeholder="Teléfono" value={nuevoContacto.telefono} onChange={e => setNuevoContacto({...nuevoContacto, telefono:e.target.value})} />
                      </div>
                      <button type="button" onClick={guardarContactoRapido} disabled={savingContacto} style={{ ...s.btnSm, marginTop:8 }}>
                        {savingContacto ? 'Guardando…' : 'Guardar contacto'}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* Items */}
              <div style={{ marginBottom:6 }}>
                <span style={s.label}>Ítems</span>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'32px 0.8fr 3.6fr 0.65fr 0.6fr 1.25fr 0.55fr 0.8fr 0.8fr 1.15fr 22px', gap:6, padding:'4px 0', marginBottom:4 }}>
                {['','Código','Descripción','Cant.','Unidad','Precio unit.','Dto%','IVA%','INC%','Total',''].map((h,i) =>
                  <div key={i} style={{ color:'#64748b', fontSize:10, fontWeight:600, textAlign: h==='Total' ? 'right' : 'left' }}>{h}</div>)}
              </div>
              {items.map((it, i) => {
                const c = calcItem(it);
                const k = itemKey(it);
                const iguales = k ? items.filter(x => itemKey(x) === k).length : 1;
                return (
                  <div key={i} style={{ marginBottom:6 }}>
                  <div style={{ ...s.itemRow, display:'grid', gridTemplateColumns:'32px 0.8fr 3.6fr 0.65fr 0.6fr 1.25fr 0.55fr 0.8fr 0.8fr 1.15fr 22px', gap:6, alignItems:'flex-start' }}>
                    <div style={s.moveCol}>
                      <button style={{ ...s.moveBtn, opacity: i === 0 ? 0.25 : 1 }} disabled={i === 0} onClick={() => moveItem(i, -1)}>▲</button>
                      <button style={{ ...s.moveBtn, opacity: i === items.length-1 ? 0.25 : 1 }} disabled={i === items.length-1} onClick={() => moveItem(i, 1)}>▼</button>
                    </div>
                    <CodigoPicker value={it.codigo || ''}
                      onChangeText={(v) => updateItem(i, 'codigo', v)}
                      onPick={(p) => pickProducto(i, p)}
                      onNew={(nombre) => openNuevoProducto(i, nombre)} />
                    <ProductoPicker value={it.descripcion}
                      onChangeText={(v) => updateItem(i, 'descripcion', v)}
                      onPick={(p) => pickProducto(i, p)}
                      onNew={(nombre) => openNuevoProducto(i, nombre)} />
                    <input style={s.inputSm} type="number" value={it.cantidad} onChange={e => updateItem(i,'cantidad',e.target.value)} />
                    <input style={s.inputSm} value={it.unidad} onChange={e => updateItem(i,'unidad',e.target.value)} />
                    <input style={s.inputSm} type="number" placeholder="0" value={it.precio_unitario} onChange={e => updateItem(i,'precio_unitario',e.target.value)} />
                    <input style={s.inputSm} type="number" min="0" max="100" value={it.descuento_pct} onChange={e => updateItem(i,'descuento_pct',e.target.value)} />
                    <select style={s.selectSm} value={it.iva_pct} onChange={e => updateItem(i,'iva_pct',e.target.value)}>
                      {IVA_OPTS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                    </select>
                    <select style={s.selectSm} value={it.impoconsumo_pct} onChange={e => updateItem(i,'impoconsumo_pct',e.target.value)}>
                      {IMPO_OPTS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                    </select>
                    <div style={{ color:'#10b981', fontSize:12, fontWeight:600, display:'flex', alignItems:'center', justifyContent:'flex-end' }}>
                      ${c.total.toLocaleString('es-CO', {maximumFractionDigits:0})}
                    </div>
                    {items.length > 1
                      ? <button style={s.removeBtn} onClick={() => removeItem(i)}>✕</button>
                      : <div />}
                  </div>
                  {iguales > 1 && (
                    <button type="button" onClick={() => aplicarPrecioAIguales(i)}
                      style={{ background:'none', border:'none', color:'#2563eb', fontSize:10, fontWeight:600, cursor:'pointer', padding:'3px 0', marginTop:2, display:'block', textAlign:'left' }}
                      title="Copia el precio de esta fila a todas las filas con el mismo ítem">
                      ⟳ Aplicar este precio a los {iguales} ítems iguales
                    </button>
                  )}
                  <input style={{ ...s.inputSm, width:'100%', marginTop:4 }} placeholder="Observación del ítem (opcional)"
                    value={it.observacion || ''} onChange={e => updateItem(i,'observacion',e.target.value)} />
                  </div>
                );
              })}

              <button style={{ ...s.btnSm, marginTop:10, marginBottom:4 }} onClick={addItem}>+ Agregar ítem</button>

              {/* Totales */}
              <div style={s.totales}>
                {descuento > 0 ? (
                  <>
                    <div style={s.totalRow}><span>Valor bruto</span><span>${brutoTotal.toLocaleString('es-CO',{maximumFractionDigits:0})}</span></div>
                    <div style={{ ...s.totalRow, color:'#f87171' }}><span>(-) Descuento</span><span>-${descuento.toLocaleString('es-CO',{maximumFractionDigits:0})}</span></div>
                    <div style={{ ...s.totalRow, borderTop:'1px solid #1e293b', paddingTop:6, marginTop:2 }}><span>Base gravable</span><span>${subtotal.toLocaleString('es-CO',{maximumFractionDigits:0})}</span></div>
                  </>
                ) : (
                  <div style={s.totalRow}><span>Subtotal</span><span>${subtotal.toLocaleString('es-CO',{maximumFractionDigits:0})}</span></div>
                )}
                {IVA_OPTS.filter(o => o.v > 0).map(o => {
                  const ivaG = items.reduce((acc, it) => Number(it.iva_pct??19)===o.v ? acc+calcItem(it).ivaVal : acc, 0);
                  return ivaG > 0 ? <div key={o.v} style={{ ...s.totalRow, color:'#fbbf24' }}><span>IVA {o.v}%</span><span>${ivaG.toLocaleString('es-CO',{maximumFractionDigits:0})}</span></div> : null;
                })}
                {IMPO_OPTS.filter(o => o.v > 0).map(o => {
                  const impoG = items.reduce((acc, it) => Number(it.impoconsumo_pct||0)===o.v ? acc+calcItem(it).impoVal : acc, 0);
                  return impoG > 0 ? <div key={`inc${o.v}`} style={{ ...s.totalRow, color:'#fb923c' }}><span>INC {o.v}%</span><span>${impoG.toLocaleString('es-CO',{maximumFractionDigits:0})}</span></div> : null;
                })}
                <div style={{ ...s.totalRow, ...s.totalFinal }}><span>Total</span><span>${total.toLocaleString('es-CO',{maximumFractionDigits:0})}</span></div>
              </div>

              <div style={{ ...s.field, marginTop:14 }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
                  <label style={{ ...s.label, margin:0 }}>Notas / condiciones comerciales</label>
                  <button type="button" style={s.condGestion} onClick={() => { setCondForm({ id:null, titulo:'', texto:'' }); setCondModal(true); }}>⚙ Gestionar predefinidas</button>
                </div>
                {condiciones.length > 0 && (
                  <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:8 }}>
                    {condiciones.map(c => {
                      const usada = condUsada(c);
                      return (
                        <button key={c.id} type="button" title={usada ? 'Ya agregada — clic para quitar' : c.texto}
                          style={{ ...s.condChip, ...(usada ? s.condChipUsada : {}) }} onClick={() => insertarCondicion(c)}>
                          {usada ? '✓ ' : '+ '}{c.titulo}
                        </button>
                      );
                    })}
                  </div>
                )}
                <textarea style={{ ...s.input, minHeight:80, resize:'vertical' }} value={form.notas} onChange={e => setForm({...form, notas:e.target.value})} />
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }} onClick={handleCreate} disabled={saving}>
                {saving ? 'Guardando...' : editandoId ? 'Guardar cambios' : copiarDe ? 'Crear copia' : 'Crear cotización'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal crear cliente al vuelo (formulario completo DIAN, compartido) */}
      {showCliente && (
        <ClienteModal
          onClose={() => setShowCliente(false)}
          onCreated={(nuevo) => {
            setClientes(prev => [...prev, nuevo].sort((a, b) => (a.razon_social || '').localeCompare(b.razon_social || '')));
            handleClienteChange(nuevo.id);
            setShowCliente(false);
          }}
        />
      )}

      {showProducto && (
        <div style={{ ...s.overlay, zIndex:200 }} onClick={() => !savingProducto && setShowProducto(false)}>
          <div style={{ ...s.modal, maxWidth:560 }} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>Nuevo producto</h2>
              <button style={s.closeBtn} onClick={() => setShowProducto(false)}>✕</button>
            </div>
            <form onSubmit={handleCrearProducto}>
              <div style={s.modalBody}>
                {errorProducto && <div style={s.errorBox}>{errorProducto}</div>}
                <div style={s.row2}>
                  <div style={s.field}>
                    <label style={s.label}>Código</label>
                    <input style={s.input} value={nuevoProducto.codigo || ''} onChange={e => setNuevoProducto({ ...nuevoProducto, codigo: e.target.value })} />
                  </div>
                  <div style={s.field}>
                    <label style={s.label}>Unidad</label>
                    <input style={s.input} value={nuevoProducto.unidad || ''} onChange={e => setNuevoProducto({ ...nuevoProducto, unidad: e.target.value })} />
                  </div>
                </div>
                <div style={s.field}>
                  <label style={s.label}>Nombre *</label>
                  <input style={s.input} value={nuevoProducto.nombre || ''} onChange={e => setNuevoProducto({ ...nuevoProducto, nombre: e.target.value })} />
                </div>
                <div style={s.row2}>
                  <div style={s.field}>
                    <label style={s.label}>Precio unitario</label>
                    <input style={s.input} type="number" min="0" value={nuevoProducto.precio_unitario} onChange={e => setNuevoProducto({ ...nuevoProducto, precio_unitario: e.target.value })} />
                  </div>
                  <div style={s.field}>
                    <label style={s.label}>IVA %</label>
                    <input style={s.input} type="number" min="0" max="100" value={nuevoProducto.iva_pct} onChange={e => setNuevoProducto({ ...nuevoProducto, iva_pct: e.target.value })} />
                  </div>
                </div>
              </div>
              <div style={s.modalFooter}>
                <button type="button" style={s.btnSecondary} onClick={() => setShowProducto(false)} disabled={savingProducto}>Cancelar</button>
                <button type="submit" style={{ ...s.btnPrimary, opacity: savingProducto ? 0.7 : 1 }} disabled={savingProducto}>
                  {savingProducto ? 'Guardando...' : 'Crear producto'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ── Vista previa post-guardado ── */}
      {preview && (
        <div style={s.overlay}>
          <div style={s.previewModal}>
            <div style={s.previewHeader}>
              <div>
                <div style={{ color:'#f1f5f9', fontWeight:700, fontSize:16 }}>Vista previa — {preview.numero}</div>
                <div style={{ color:'#64748b', fontSize:12, marginTop:2 }}>Cotización guardada correctamente</div>
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <button style={s.btnAction} onClick={handleDownload} disabled={!pdfUrl}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="15" height="15"><path d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16"/></svg>
                  Descargar
                </button>
                <button style={s.btnAction} onClick={handlePrint} disabled={!pdfUrl}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="15" height="15"><path d="M6 9V3h12v6M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8" rx="1"/></svg>
                  Imprimir
                </button>
                <button style={s.btnAction} onClick={() => setEmailModal(true)}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="15" height="15"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg>
                  Enviar al cliente
                </button>
                <button style={s.btnSecondary} onClick={closePreview}>Cerrar</button>
              </div>
            </div>
            <div style={s.previewBody}>
              {pdfLoading && (
                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', gap:12, color:'#64748b' }}>
                  <div style={s.spinner} />
                  <span>Generando PDF…</span>
                </div>
              )}
              {!pdfLoading && pdfUrl && (
                <iframe src={`${pdfUrl}#toolbar=0&navpanes=0&view=FitH`} style={{ width:'794px', height:`${Math.round(794 * pdfAspect)}px`, border:'none', boxShadow:'0 4px 24px rgba(0,0,0,0.5)', flexShrink:0 }} title={preview.numero} />
              )}
            </div>
          </div>
        </div>
      )}

      {emailModal && preview && (
        <ModalEmail tipo="cotizacion" id={preview.id} destinatario={preview.clienteEmail} onClose={() => setEmailModal(false)} />
      )}

      {/* ── Modal copiar ── */}
      {modalCopiar && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:460 }}>
            <div style={s.modalHeader}>
              <h2 style={s.modalTitle}>Copiar cotización</h2>
              <button style={s.closeBtn} onClick={() => setModalCopiar(null)}>✕</button>
            </div>
            <div style={s.modalBody}>
              <p style={{ color:'#94a3b8', fontSize:13, marginBottom:16 }}>
                Origen: <strong style={{ color:'#f1f5f9' }}>{String(modalCopiar.numero).replace(/-v\d+$/, '')}</strong>
                {' — '}Se crea una <strong>cotización nueva</strong> con el siguiente consecutivo
                (puedes cambiar el cliente si quieres). Para revisar la original sin duplicarla, edítala: se queda en la misma y sube la versión.
              </p>
              <div style={s.field}>
                <label style={s.label}>Cliente</label>
                <select style={s.input} value={copiarClienteId} onChange={e => setCopiarClienteId(e.target.value)}>
                  {clientes.map(c => <option key={c.id} value={c.id}>{c.razon_social}</option>)}
                </select>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModalCopiar(null)}>Cancelar</button>
              <button style={{ ...s.btnPrimary, opacity: copiando ? 0.7 : 1 }} onClick={handleCopiar} disabled={copiando}>
                {copiando ? 'Copiando...' : 'Copiar cotización'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal gestionar condiciones comerciales predefinidas */}
      {condModal && (
        <div style={s.overlay}>
          <div style={{ ...s.modal, maxWidth:560 }}>
            <div style={s.modalHeader}><h2 style={s.modalTitle}>Condiciones comerciales predefinidas</h2><button style={s.closeBtn} onClick={() => setCondModal(false)}>✕</button></div>
            <div style={s.modalBody}>
              <p style={{ color:'#94a3b8', fontSize:13, marginTop:0 }}>Crea plantillas de condiciones para insertarlas con un clic al cotizar.</p>
              <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:16 }}>
                {condiciones.length === 0 && <p style={{ color:'#64748b', fontSize:13 }}>Aún no hay condiciones. Crea la primera abajo.</p>}
                {condiciones.map(c => (
                  <div key={c.id} style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'10px 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8 }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ color:'#f1f5f9', fontSize:13, fontWeight:600 }}>{c.titulo}</div>
                      <div style={{ color:'#94a3b8', fontSize:12, whiteSpace:'pre-wrap', marginTop:2 }}>{c.texto}</div>
                    </div>
                    <button style={s.condGestion} onClick={() => setCondForm({ id:c.id, titulo:c.titulo, texto:c.texto })}>Editar</button>
                    <button style={{ ...s.condGestion, color:'#fca5a5' }} onClick={() => eliminarCondicion(c)}>Eliminar</button>
                  </div>
                ))}
              </div>
              <div style={{ borderTop:'1px solid #334155', paddingTop:14 }}>
                <div style={{ color:'#cbd5e1', fontSize:13, fontWeight:600, marginBottom:8 }}>{condForm.id ? 'Editar condición' : 'Nueva condición'}</div>
                <div style={s.field}><label style={s.label}>Título (ej. "Forma de pago", "Validez")</label>
                  <input style={s.input} value={condForm.titulo} onChange={e => setCondForm({ ...condForm, titulo:e.target.value })} />
                </div>
                <div style={{ ...s.field, marginTop:10 }}><label style={s.label}>Texto de la condición</label>
                  <textarea style={{ ...s.input, minHeight:70, resize:'vertical' }} value={condForm.texto} onChange={e => setCondForm({ ...condForm, texto:e.target.value })} />
                </div>
                <div style={{ display:'flex', gap:8, marginTop:12 }}>
                  {condForm.id && <button style={s.btnSecondary} onClick={() => setCondForm({ id:null, titulo:'', texto:'' })}>Cancelar edición</button>}
                  <button style={s.btnPrimary} onClick={guardarCondicion}>{condForm.id ? 'Guardar cambios' : '+ Agregar condición'}</button>
                </div>
              </div>
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setCondModal(false)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  pageHeader: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:6 },
  h1:         { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:        { color:'#64748b', fontSize:14, margin:0 },
  btnPrimary: { background:'#1d4ed8', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSecondary:{ background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' },
  btnNuevoCli: { background:'#1e3a5f', border:'1px solid #3b82f6', color:'#7dd3fc', borderRadius:6, padding:'4px 10px', fontSize:12, fontWeight:500, cursor:'pointer' },
  tabs: { display:'flex', gap:8, marginBottom:16 },
  tab: { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:8, padding:'8px 16px', fontSize:13, cursor:'pointer' },
  tabActive: { background:'#1e3a5f', border:'1px solid #3b82f6', color:'#7dd3fc' },
  acDropdown: { position:'absolute', top:'100%', left:0, right:0, zIndex:300, background:'#0f172a', border:'1px solid #3b82f6', borderRadius:8, marginTop:2, maxHeight:220, overflowY:'auto', boxShadow:'0 8px 24px rgba(0,0,0,0.5)' },
  acItem: { padding:'6px 10px', cursor:'pointer', borderBottom:'1px solid #1e293b' },
  acItemNew: { position:'sticky', top:0, background:'#0f172a', borderBottom:'1px solid #334155', zIndex:2 },
  errorBox:    { background:'#450a0a', border:'1px solid #b91c1c', borderRadius:8, color:'#fca5a5', padding:'10px 14px', marginBottom:16, fontSize:13 },
  btnSm:      { background:'#1e40af', color:'#93c5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  filtros:    { display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' },
  chip:       { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'6px 14px', borderRadius:20, fontSize:12, cursor:'pointer' },
  chipActive: { background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  fInput:     { background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'0 11px', height:38, boxSizing:'border-box', color:'#f1f5f9', fontSize:13, minWidth:180 },
  iconBox:    { height:38, width:38, boxSizing:'border-box', display:'inline-flex', alignItems:'center', justifyContent:'center', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#94a3b8', cursor:'pointer', padding:0 },
  iconBoxActive:{ background:'#1d4ed8', borderColor:'#1d4ed8', color:'#fff' },
  filtroMenu: { position:'absolute', top:'calc(100% + 6px)', left:0, zIndex:40, background:'#0f172a', border:'1px solid #334155', borderRadius:10, padding:6, minWidth:180, boxShadow:'0 12px 32px rgba(0,0,0,.45)', display:'flex', flexDirection:'column', gap:2 },
  filtroItem: { textAlign:'left', background:'transparent', color:'#cbd5e1', border:'none', padding:'8px 12px', borderRadius:6, cursor:'pointer', fontSize:13, textTransform:'capitalize' },
  filtroItemActive:{ background:'#1d4ed8', color:'#fff', fontWeight:600 },
  filtroPanel: { position:'absolute', top:0, right:'calc(100% + 8px)', zIndex:50, background:'#0f172a', border:'1px solid #334155', borderRadius:12, padding:16, display:'flex', gap:20, alignItems:'flex-start', boxShadow:'0 16px 40px rgba(0,0,0,.5)' },
  filtroLabel: { color:'#64748b', fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:'.03em', marginBottom:6 },
  chipSm: { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', padding:'5px 12px', borderRadius:16, fontSize:12, cursor:'pointer' },
  condChip: { background:'#0e2038', border:'1px solid #1e3a5f', color:'#93c5fd', padding:'5px 12px', borderRadius:16, fontSize:12, cursor:'pointer', whiteSpace:'nowrap', maxWidth:220, overflow:'hidden', textOverflow:'ellipsis' },
  condChipUsada: { background:'#052e16', border:'1px solid #166534', color:'#86efac' },
  condGestion: { background:'transparent', border:'none', color:'#7dd3fc', fontSize:12, cursor:'pointer', whiteSpace:'nowrap', padding:0 },
  card:       { background:'#1e293b', borderRadius:12, overflow:'hidden' },
  table:      { width:'100%', borderCollapse:'collapse' },
  th:         { padding:'8px 16px', color:'#64748b', fontSize:12, textAlign:'left', borderBottom:'1px solid #334155', background:'#162032', whiteSpace:'nowrap', verticalAlign:'middle' },
  tr:         { transition:'background .1s' },
  td:         { padding:'4px 16px', color:'#cbd5e1', fontSize:13, borderBottom:'1px solid #1a2332' },
  empty:      { padding:'32px', textAlign:'center', color:'#475569' },
  badge:      { padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 },
  select:     { background:'#0f172a', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'3px 8px', fontSize:12, cursor:'pointer' },
  btnFacturar:{ background:'#4c1d95', color:'#c4b5fd', border:'none', borderRadius:6, padding:'4px 10px', fontSize:12, fontWeight:600, cursor:'pointer', whiteSpace:'nowrap' },
  overlay:    { position:'fixed', inset:0, background:'rgba(0,0,0,.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
  modal:      { background:'#1e293b', borderRadius:16, width:'97%', maxWidth:1200, maxHeight:'90vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  modalHeader:{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'13px 20px', borderBottom:'1px solid #334155' },
  modalTitle: { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:0 },
  closeBtn:   { background:'transparent', border:'none', color:'#64748b', fontSize:18, cursor:'pointer' },
  modalBody:  { padding:'14px 20px', overflowY:'auto', flex:1 },
  modalFooter:{ display:'flex', justifyContent:'flex-end', gap:10, padding:'12px 20px', borderTop:'1px solid #334155' },
  row2:       { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:16 },
  field:      { marginBottom:10 },
  label:      { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input:      { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, boxSizing:'border-box', outline:'none' },
  inputSm:    { width:'100%', height:34, padding:'0 8px', background:'#0f172a', border:'1px solid #334155', borderRadius:6, color:'#f1f5f9', fontSize:12, boxSizing:'border-box', outline:'none' },
  selectSm:   { width:'100%', height:34, padding:'0 6px', background:'#0f172a', border:'1px solid #334155', borderRadius:6, color:'#f1f5f9', fontSize:12, boxSizing:'border-box', outline:'none', cursor:'pointer' },
  itemsHeader:{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:8 },
  itemRow:    { display:'flex', gap:8, alignItems:'center', marginBottom:8 },
  moveCol:    { display:'flex', flexDirection:'column', gap:1 },
  moveBtn:    { background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', borderRadius:4, padding:'1px 4px', fontSize:9, cursor:'pointer', lineHeight:1.4 },
  itemTotal:  { color:'#10b981', fontSize:13, minWidth:90, textAlign:'right', fontWeight:600 },
  removeBtn:  { background:'#450a0a', border:'none', color:'#fca5a5', borderRadius:6, padding:'4px 8px', cursor:'pointer', fontSize:12 },
  totales:     { background:'#0f172a', borderRadius:10, padding:'14px 18px', marginTop:12, marginLeft:'auto', width:260 },
  totalRow:    { display:'flex', justifyContent:'space-between', color:'#94a3b8', fontSize:13, marginBottom:6 },
  totalFinal:  { color:'#f1f5f9', fontWeight:700, fontSize:15, borderTop:'1px solid #334155', paddingTop:8, marginTop:4 },
  hint:        { color:'#475569', fontWeight:400, fontStyle:'italic' },
  noContactos: { background:'#0f172a', border:'1px dashed #334155', borderRadius:8, padding:'9px 12px', color:'#475569', fontSize:12 },
  previewModal:{ background:'#1e293b', borderRadius:16, width:'98%', maxWidth:960, height:'95vh', display:'flex', flexDirection:'column', border:'1px solid #334155' },
  previewHeader:{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #334155', flexShrink:0 },
  previewBody: { flex:1, overflowY:'auto', background:'#374151', display:'flex', flexDirection:'column', alignItems:'center', padding:'24px 16px' },
  btnAction:   { display:'flex', alignItems:'center', gap:6, background:'#1e293b', border:'1px solid #475569', color:'#e2e8f0', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  btnCopy:     { display:'flex', alignItems:'center', gap:5, background:'#1e293b', border:'1px solid #334155', color:'#94a3b8', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' },
  spinner:     { width:32, height:32, border:'3px solid #1e293b', borderTop:'3px solid #3b82f6', borderRadius:'50%', animation:'spin 0.8s linear infinite' },
};
